import React from 'react';
import UPPage from '../components/UPPage';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';

/**
 * Recovery Email Sent page
 */
export const RecoveryEmailSent = () => {
  const { t } = useTranslation('translation');

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center" pb={5}>
        {t('passwordResetHeader')}
      </Typography>
      <Typography pb={3}>{t('recoveryEmailSent')}</Typography>
      <Typography alignSelf={'self-start'}>{t('notReceivedEmail')}</Typography>
      <Link alignSelf={'self-start'} href={'/auth/'} sx={{ cursor: 'pointer' }}>
        {t('returnToLoginPage')}
      </Link>
    </UPPage>
  );
};
